import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useStore, useTask } from 'engine/store';
import { X } from 'lucide-react';

import { Button } from 'components/Button';
import { BunnyMediaRenderer } from 'components/BunnyMediaRenderer';

export const Route = createFileRoute('/ar-scene/$roundId/$taskId')({
	component: RouteComponent,
	// TODO: maybe redirect back to task screen if task is not of task type fullscreen video
});

// const project = 'https://headtiltdev.8thwall.app/ubgames-dev/'; //Studio Project
const project = 'https://headtiltdev.8thwall.app/ubgames-test/'; // Legacy (react + a-frame) project
// const project = 'https://kalpitdwivedi.8thwall.app/charachter-test/';
const modelOptions = ['pagoda', 'carnavalwagen', 'karaf', 'kruidenkraam', 'moskee', 'vrijheidsbeeld', 'ukraine', 'sitar'] as const;

export type ModelTypes = (typeof modelOptions)[number];

function RouteComponent() {
	const params = Route.useParams();
	const navigate = useNavigate();
	const t = useTask(params.roundId, params.taskId);
	const submitTaskSubmission = useStore((s) => s.submitTaskSubmission);

	if (t.task?.type !== 'augmented-reality') {
		throw new Error('Task is not of type augmented-reality');
	}

	const model = t.task?.typeAugmentedRealityConfig?.model;
	let eightWallParams = '';
	if (model && modelOptions.includes(model)) eightWallParams = eightWallParams + `?model=${model}`;
	const projectLink = project + eightWallParams;

	console.log('wanted model ', model);

	const submitViewed = () => {
		submitTaskSubmission({
			taskId: params.taskId,
			answer: { kind: 'text', text: 'ar-viewed' },
			status: 'in-progress',

			// unused fields
			attempts: 1,
			unlocked: true,
			pointsGiven: 0,
		});
		navigate({ to: '/rounds/$roundId/task/$taskId', replace: true, params: { roundId: params.roundId, taskId: params.taskId } });
	};
	return (
		<>
			<div className="relative size-full">
				<div className="hidden">{t?.task.media && <BunnyMediaRenderer media={t.task.media} autoplay={true} />}</div>
				<>
					<iframe
						key={'AR-iframe'}
						className="bg-red fixed inset-0 h-screen w-screen"
						src={projectLink}
						allow="camera;gyroscope;accelerometer;magnetometer;xr-spatial-tracking;"
					/>

					<Button className="absolute left-5 top-5 z-50 rounded" onClick={submitViewed}>
						<X className="size-8" />
					</Button>
				</>
			</div>
		</>
	);
}
